<template>

  <div>
    <v-app>

      <headerSection v-if="$route.path !== '/impressum' && $route.path !== '/datenschutz'"></headerSection>

      <v-main>
        <router-view></router-view>
      </v-main>

      <v-fab-transition>
        <v-btn v-show="showScrollButton" fab dark
               class="primary-bg scroll-to-top text-white position-fixed right-0 bottom-0 mr-6 mb-6" @click="scrollToTop"
               icon="mdi-chevron-up"></v-btn>
      </v-fab-transition>
    </v-app>
  </div>

</template>

<style>
.v-main {
  padding: 0;
}
</style>

<script>
import headerSection from "@/components/headerSection.vue";

export default {
  name: 'App',
  components: {headerSection},
  data: () => ({
    showScrollButton: false
  }),
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0
      this.showScrollButton = window.scrollY > 400
    },
    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
  }
}
</script>
